import KunLoading111 from './src/index'

KunLoading111.install = function (Vue) {
	Vue.component(KunLoading111.name, KunLoading111);
}

export default KunLoading111;
